module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header-inner"
  }, [_c('div', {
    staticClass: "header-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "7em"
    },
    attrs: {
      "src": "static/assets/img/cnpay-logo.png",
      "alt": "Logo"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-bottom"
  }, [_c('div', {
    staticClass: "pull-left hidden-lg hidden-md",
    staticStyle: {
      "padding-top": "1em",
      "font-size": "18px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/rewards",
      "title": "My Rewards"
    }
  }, [_vm._v(" \r\n                                        ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)) + " "), _c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae"
    }
  }, [_vm._v("Rewards ")]), _c('span', {
    staticStyle: {
      "color": "#daa520"
    }
  }, [_vm._v("Balance")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right hidden-sm hidden-xs",
    staticStyle: {
      "padding-top": "1em",
      "font-size": "18px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/rewards",
      "title": "My Rewards"
    }
  }, [_vm._v(" \r\n                                        ₦" + _vm._s(_vm.formatCurrency(_vm.current_wallet_balance)) + " "), _c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#22baae"
    }
  }, [_vm._v("Rewards ")]), _c('span', {
    staticStyle: {
      "color": "#daa520"
    }
  }, [_vm._v("Balance")])])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "header-nav-primary nav nav-pills collapse navbar-collapse"
  }, [(_vm.user != null || _vm.user != undefined) ? [_c('li', [(_vm.user != '') ? _c('router-link', {
    attrs: {
      "to": "'"
    }
  }, [_vm._v("Hello, " + _vm._s(_vm.user) + " "), _c('i', {
    staticClass: "fa fa-chevron-down"
  })]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Logout")])], 1)])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/rewards"
    }
  }, [_vm._v("My Rewards")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Pay Bills, Buy Airtime ")])], 1)] : [_vm._m(2), _vm._v(" "), _vm._m(3)]], 2), _vm._v(" "), _vm._m(4)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top"
  }, [_c('ul', {
    staticClass: "header-nav-social social-links nav nav-pills"
  }, [_c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/cityneedsng"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://web.facebook.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": " https://www.instagram.com/cityneeds/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://linkedin.com/in/cityneeds-technologies-00b090138"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://cityneeds.ng/dashboard",
      "target": "_blank"
    }
  }, [_vm._v("View Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/?login=login"
    }
  }, [_vm._v("Log In")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://cityneeds.ng/register",
      "target": "_blank"
    }
  }, [_vm._v("Sign Up    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": ".header-nav-primary"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bd8eaca"}!./src/components/Second-Header/template.html
// module id = 99
// module chunks = 1